// Pokemon ID ranges per generation
export const GENERATION_RANGES: Record<number, [number, number]> = {
  1: [1, 151],
  2: [152, 251],
  3: [252, 386],
  4: [387, 493],
  5: [494, 649],
  6: [650, 721],
  7: [722, 809],
  8: [810, 905],
  9: [906, 1025],
};

// Legendary Pokemon IDs (all gens)
export const LEGENDARY_IDS: Set<number> = new Set([
  144, 145, 146, 150, // Gen 1
  243, 244, 245, 249, 250, // Gen 2
  377, 378, 379, 380, 381, 382, 383, 384, // Gen 3
  480, 481, 482, 483, 484, 485, 486, 487, 488, // Gen 4
  638, 639, 640, 641, 642, 643, 644, 645, 646, // Gen 5
  716, 717, 718, // Gen 6
  772, 773, 785, 786, 787, 788, 789, 790, 791, 792, 800, // Gen 7
  888, 889, 890, 891, 892, 895, 896, 897, 898, // Gen 8
  1001, 1002, 1003, 1004, 1007, 1008, 1014, 1015, 1016, 1017, 1024, 1025, // Gen 9
]);

// Mythical Pokemon IDs
export const MYTHICAL_IDS: Set<number> = new Set([
  151, // Mew
  251, // Celebi
  385, 386, // Jirachi, Deoxys
  489, 490, 491, 492, 493, // Gen 4
  494, 647, 648, 649, // Gen 5
  719, 720, 721, // Gen 6
  801, 802, 807, 808, 809, // Gen 7
  893, // Zarude
]);

export function getGenerationForId(id: number): number {
  for (const [gen, [min, max]] of Object.entries(GENERATION_RANGES)) {
    if (id >= min && id <= max) return Number(gen);
  }
  return 0;
}
